import type { ActivityType } from './ActivityType'

export type ActivityActionType = 'follow' | 'unfollow'

const oppositeMap = {
  unfollow: 'follow',
  follow: 'unfollow',
} as const satisfies Record<ActivityActionType, ActivityActionType>

export const opposite = <T extends ActivityActionType>(type: T) =>
  oppositeMap[type]

const actionMap = {
  'not-following': 'follow',
  following: 'unfollow',
} as const satisfies Record<ActivityType, ActivityActionType>

export const forActivityType = <T extends ActivityType>(type: T) =>
  actionMap[type]
